import React, { useState } from "react"
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { TextField } from "@material-ui/core";
import { Alert, Button, Hidden } from "@mui/material";
import { useForm } from "react-hook-form";

const Signup = () => {
    const shrinkProp = { shrink: true };
    const { register, handleSubmit, getValues, setError, formState: { errors } } = useForm()
    const [showOtp, setShowOtp] = useState(false)
    const [showGenerateTOTP, setShowGenerateTOTP] = useState(false)
    const [showTOTP, setShowTOTP] = useState(false)
    const [signupMessage, setSignupMessage] = useState();
    const [signupErrorMessage, setSignupErrorMessage] = useState();
    const [generateOtpErrorMessage, setGenerateOtpErrorMessage] = useState();
    const [otpErrorMessage, setOtpErrorMessage] = useState();
    const [tOtpErrorMessage, setTOtpErrorMessage] = useState();

    const onSubmit = data => {
        console.log(JSON.stringify(data))

        fetch('/algo-trading/public/api/signup', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(function (response) {
            response.text().then(r => {
                console.log(r);
                if (response.ok) {
                    setSignupErrorMessage('')
                    setShowOtp(true)
                }
                else {
                    setSignupErrorMessage(r)
                }
            })
        }, function (error) {
            console.log(error.message)
            setSignupErrorMessage(error.message)
        })
    }
    const validateOtp = event => {
        const request = new Object();
        request.clientCode = getValues("clientCode");
        request.mobile = getValues("mobile");
        request.email = getValues("email");
        request.emailOtp = getValues("emailOtp");
        request.mobileOtp = getValues("mobileOtp");
        request.brokerName = getValues("broker");
        console.log(JSON.stringify(request))

        fetch('/algo-trading/public/api/validate-otp', {
            method: 'POST',
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(function (response) {
            response.text().then(r => {
                console.log(r);
                if (response.ok) {
                    setOtpErrorMessage('')
                    setShowGenerateTOTP(true)
                }
                else {
                    setOtpErrorMessage(r)
                }
            })
        }, function (error) {
            console.log(error.message)
            setOtpErrorMessage(error.message)
        })
    }

    const generateOtp = event => {
        fetch(`/algo-trading/public/api/generate-totp?clientCode=${getValues("clientCode")}&pin=${getValues("password")}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
            }
        }).then(function (response) {
            response.text().then(r => {
                console.log(r);
                if (response.ok) {
                    setGenerateOtpErrorMessage('')
                    setShowTOTP(true)
                }
                else {
                    setGenerateOtpErrorMessage(r)
                }
            })
        }, function (error) {
            console.log(error.message)
            setGenerateOtpErrorMessage(error.message)
        })
    }

    const validateTOtpOtp = event => {
        const request = new Object();
        request.clientCode = getValues("clientCode");
        request.email = getValues("email");
        request.pin = getValues("password");
        request.mobileOtp = getValues("totpOtp");
        request.brokerName = getValues("broker");
        console.log(JSON.stringify(request))

        fetch('/algo-trading/public/api/validate-totp-otp', {
            method: 'POST',
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
            }
        }).then(function (response) {
            response.text().then(r => {
                console.log(r);
                if (response.ok) {
                    setTOtpErrorMessage('')
                    setSignupMessage('User signed up successfully')
                }
                else {
                    setTOtpErrorMessage(r)
                }
            })
        }, function (error) {
            console.log(error.message)
            setTOtpErrorMessage(error.message)
        })
    }

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h4" gutterBottom component="div">
                    Sign Up
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom component="div">
                    Share your details with us and we will shortly get in touch with you.
                </Typography>
            </Grid>
            <form name="signupForm" onSubmit={handleSubmit(onSubmit)}>
                <Grid container item spacing={2} xs={12} md={3}>
                    <Grid item xs={12}>
                        <TextField label="Broker" variant="outlined" size="small" fullWidth
                            InputLabelProps={shrinkProp}
                            error={errors && !!errors['broker']}
                            helperText={errors && !!errors['broker'] && 'required field'}
                            hidden={true}
                            inputProps={
                                { readOnly: true, }
                            }
                            defaultValue="ANGEL_ONE"
                            {...register('broker', { required: true })} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField label="Name" variant="outlined" size="small" placeholder="First Name Last Name"
                            fullWidth
                            InputLabelProps={shrinkProp}
                            inputProps={
                                { readOnly: showOtp, }
                            }
                            error={errors && !!errors['name']}
                            helperText={errors && !!errors['name'] && 'required field'}
                            {...register('name', { required: true })} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField label="Mobile" variant="outlined" size="small" type="number" placeholder="Indian Mobile Number w/o country code " fullWidth
                            InputLabelProps={shrinkProp}
                            inputProps={
                                { readOnly: showOtp, }
                            }
                            error={errors && !!errors['mobile']}
                            helperText={errors && !!errors['mobile'] && 'required field 10 digits'}
                            {...register('mobile', { required: true, minLength: 10, maxLength: 10 })} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField label="Email" variant="outlined" size="small" type={"email"} placeholder="Email Address" fullWidth
                            InputLabelProps={shrinkProp}
                            inputProps={
                                { readOnly: showOtp, }
                            }
                            error={errors && !!errors['email']}
                            helperText={errors && !!errors['email'] && 'required field'}
                            {...register('email', { required: true })} />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <TextField label="Client Id" variant="outlined" size="small" placeholder="AngelOne Client Id"
                            fullWidth
                            InputLabelProps={shrinkProp}
                            inputProps={
                                { readOnly: showOtp, }
                            }
                            error={errors && !!errors['clientCode']}
                            helperText={errors && !!errors['clientCode'] && 'required field'}
                            {...register('clientCode', { required: true })} />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <TextField label="Pin" variant="outlined" size="small" placeholder="AngelOne pin number"
                            fullWidth
                            InputLabelProps={shrinkProp}
                            inputProps={
                                { readOnly: showOtp, }
                            }
                            error={errors && !!errors['password']}
                            helperText={errors && !!errors['password'] && 'required field 4 digits'}
                            {...register('password', { required: true, minLength: 4, maxLength: 4 })} />
                    </Grid>
                    <Grid item xs={12}>
                        <Button disabled={showOtp} variant="contained" type="submit">Signup</Button>
                    </Grid>
                    {signupErrorMessage && (<Alert variant={"filled"} severity="warning">{signupErrorMessage}</Alert>)}
                    {showOtp &&
                        <>
                            <Grid item xs={6}>
                                <TextField label="Mobile Otp" variant="outlined" size="small" fullWidth
                                    InputLabelProps={shrinkProp}
                                    inputProps={
                                        { readOnly: showGenerateTOTP, }
                                    }
                                    error={errors && !!errors['mobileOtp']}
                                    helperText={errors && !!errors['mobileOtp'] && 'required field'}
                                    {...register('mobileOtp', { required: true })} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField label="Email Otp" variant="outlined" size="small" fullWidth
                                    InputLabelProps={shrinkProp}
                                    inputProps={
                                        { readOnly: showGenerateTOTP, }
                                    }
                                    error={errors && !!errors['emailOtp']}
                                    helperText={errors && !!errors['emailOtp'] && 'required field'}
                                    {...register('emailOtp', { required: true })} />
                            </Grid>
                            <Grid item xs={12}>
                                <Button disabled={showGenerateTOTP} variant="contained" type="button" onClick={(event) => validateOtp(event)}>Verify OTP</Button>
                            </Grid>
                        </>
                    }
                    {generateOtpErrorMessage && (<Alert variant={"filled"} severity="warning">{generateOtpErrorMessage}</Alert>)}
                    {showGenerateTOTP &&
                        <>
                            <Grid item xs={12}>
                                <Button disabled={showTOTP} variant="contained" type="button" onClick={(event) => generateOtp(event)}>Verify TOTP OTP</Button>
                            </Grid>
                        </>
                    }
                    {otpErrorMessage && (<Alert variant={"filled"} severity="warning">{otpErrorMessage}</Alert>)}
                    {showTOTP &&
                        <>
                            <Grid item xs={12}>
                                <TextField label="TOTP otp" variant="outlined" size="small" fullWidth
                                    InputLabelProps={shrinkProp}
                                    error={errors && !!errors['totpOtp']}
                                    helperText={errors && !!errors['totpOtp'] && 'required field'}
                                    {...register('totpOtp', { required: true })} />
                            </Grid>
                            <Grid item xs={12}>
                                <Button variant="contained" type="button" onClick={(event) => validateTOtpOtp(event)}>Verify TOTP OTP</Button>
                            </Grid>
                        </>
                    }
                    {tOtpErrorMessage && (<Alert variant={"filled"} severity="warning">{tOtpErrorMessage}</Alert>)}
                    {signupMessage && (<Alert variant={"filled"} severity="success">{signupMessage}</Alert>)}
                </Grid>
            </form>
        </>
    )
}

export default Signup